export module UnescapeHelper {
  export const unescape = (input: string) => {
    const e = document.createElement('textarea')
    e.innerHTML = input
    // handle case of empty input
    return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue
  }
}
